import { render } from "./ChallengeResults.vue?vue&type=template&id=1bde4817&scoped=true"
import script from "./ChallengeResults.vue?vue&type=script&lang=js"
export * from "./ChallengeResults.vue?vue&type=script&lang=js"

import "./ChallengeResults.vue?vue&type=style&index=0&id=1bde4817&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bde4817"]])

export default __exports__